// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DKoU","rootMobile":"styles_rootMobile__1ojh4"};